import { useEffect } from 'react';
import { Send } from 'lucide-react';
import { toast } from 'sonner';
import { useAuth } from '@/shared/lib/auth';
import { isMasterEmail } from '@/shared/lib/navigation';

interface CampaignDispatchNotice {
  type?: string;
  nome?: string;
  tipoDisparo?: string;
  total?: number;
  idCampanha?: string;
}

/** Ouve o websocket do BFF e avisa o master quando uma campanha começa a disparar. */
export function CampaignDispatchNotifier() {
  const { user } = useAuth();
  const master = isMasterEmail(user?.email);

  useEffect(() => {
    if (!master) return;
    let cancelled = false;
    let socket: WebSocket | null = null;
    let retry: ReturnType<typeof setTimeout> | undefined;

    const connect = () => {
      if (cancelled) return;
      const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
      socket = new WebSocket(`${protocol}//${window.location.host}/bff/notifications`);
      socket.onmessage = (event) => {
        let notice: CampaignDispatchNotice;
        try {
          notice = JSON.parse(String(event.data)) as CampaignDispatchNotice;
        } catch {
          return;
        }
        if (notice.type !== 'campaign-dispatch') return;
        const nome = notice.nome?.trim() || 'Campanha';
        const canal = notice.tipoDisparo?.trim() || 'push';
        const total = notice.total ?? 0;
        toast('Campanha em disparo', {
          id: `campaign-dispatch-${notice.idCampanha || nome}`,
          description: `${nome} · ${canal} · ${total} destinatário${total === 1 ? '' : 's'}`,
          icon: <Send className="size-4" />,
          duration: 8000,
        });
      };
      socket.onclose = () => {
        if (!cancelled) retry = setTimeout(connect, 4000);
      };
    };

    connect();
    return () => {
      cancelled = true;
      if (retry) clearTimeout(retry);
      socket?.close();
    };
  }, [master]);

  return null;
}
